// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const commonErrorApiCodeResourcesMicroLab = {
  microLabLibraryEntry: "Micro Lab ライブラリエントリ",
  microLabMember: "Micro Lab メンバー",
  microLabRelease: "Micro Lab リリース",
  microLabRun: "Micro Lab 実行",
  microLabScheme: "Micro Lab スキーム",
  microLabSchemeVersion: "Micro Lab スキームバージョン",
  microLabAuth: "Micro Lab 認証",
  microLabLibrary: "Micro Lab ライブラリ",
} as const;
